import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { inject } from '@app/providers/QAU.ContextProvider';
import { setToolPanelOverlayLayout } from '@app/actions/customizeActions';
import { setFooterConfig } from '@app/actions/footerActions';

import ToolGroupOverlay from './tool-group-overlay/ToolGroupOverlay';
import SizeGroup from './tool-groups/SizeGroup';
import PositionGroup from './tool-groups/PositionGroup';
import { isMobileMode, isTabletMode, isStickerFlow, isSheetFlow, isCustomShapeFlow } from '@app/utils/utils';
import { isCreatedFromDielineShape } from '@app/utils/hints';
import './SideToolPanel.scss';

const SideToolPanel = ({
  setToolPanelOverlayLayout,
  sizeGroupEnabled,
  toolPanelOverlayLayout,
  positionGroupEnabled,
  isShapeChanged,
  isCornerTypeChanged,
  isSizeChanged,
  setFooterConfig,
  isMobileView,
  isTabletView,
}) => {
  const toggleToolGroupOverlay = ({ currentTarget }, overlayLayout) => {
    const activeToolGroup = document.querySelector('.tool-group.active');
    activeToolGroup && activeToolGroup.classList.remove('active');

    if (activeToolGroup === currentTarget) {
      setToolPanelOverlayLayout(null);
    } else {
      currentTarget.classList.add('active');
      setToolPanelOverlayLayout(overlayLayout);
    }
  };

  useEffect(() => {
    const isMoveArtActive = toolPanelOverlayLayout?.props?.id === 'qau-toolgroup-position';
    const isNoteVisible = !isMobileView && !isTabletView && isMoveArtActive;

    isNoteVisible && setFooterConfig({
      noteMessageLocKey: 'qau-move-art-tools-note-message-text',
    });
  }, [toolPanelOverlayLayout]);

  const props = {
    className: 'tool-group',
    toggleOverlay: toggleToolGroupOverlay,
  };

  return (
    <div id="qau-side-tool-panel">
      <SizeGroup
        id="size-toolgroup"
        visible={sizeGroupEnabled}
        {...props}
      />
      <PositionGroup
        id="position-toolgroup"
        visible={positionGroupEnabled}
        disabled={isShapeChanged || isCornerTypeChanged || isSizeChanged}
        {...props}
      />
      <ToolGroupOverlay
        overlayLayout={toolPanelOverlayLayout}
      />
    </div>
  );
};

const mapStateToProps = ({ customize, matrix: { ctx } }, { flowConfig, context }) => {
  const {
    customizeData: {
      toolPanelOverlayLayout,
      resizeParams: { isShapeChanged, isCornerTypeChanged, isSizeChanged },
    },
  } = customize;

  return {
    positionGroupEnabled: !isCustomShapeFlow(flowConfig) && !isCreatedFromDielineShape(context),
    sizeGroupEnabled: isStickerFlow(flowConfig) || isSheetFlow(flowConfig),
    isMobileView: isMobileMode(ctx),
    isTabletView: isTabletMode(ctx),
    toolPanelOverlayLayout,
    isShapeChanged,
    isCornerTypeChanged,
    isSizeChanged,
  };
};

const mapDispatchToProps = {
  setToolPanelOverlayLayout,
  setFooterConfig,
};

SideToolPanel.propTypes = {
  toolPanelOverlayLayout: PropTypes.node,
  isMobileView: PropTypes.bool.isRequired,
  positionGroupEnabled: PropTypes.bool.isRequired,
  sizeGroupEnabled: PropTypes.bool.isRequired,
  setToolPanelOverlayLayout: PropTypes.func.isRequired,
  setFooterConfig: PropTypes.func.isRequired,
  context: PropTypes.object.isRequired,
};

export default inject('flowConfig', 'context')(connect(mapStateToProps, mapDispatchToProps)(SideToolPanel));
